module.exports = {
  title: 'iHeartColors',
  description: `
    A full screen javascript-­driven color picker that allows you to pick colors using mouse coordinates to save palettes to your account and public gallery, currently in pre-­alpha stages.
    Temporarily taken down until I have time to work on it (hosting is expensive, eh?).
  `,
  tags: ['Angular', 'CSS', 'Design', 'JavaScript', 'MongoDB', 'Node',],
  images: [require('./images/1.jpg'), require('./images/2.jpg'), require('./images/3.jpg'),],
};



// WEBPACK FOOTER //
// ./src/data/works/iheartcolors/index.js